import { render, staticRenderFns } from "./GoalDialog.vue?vue&type=template&id=51bd53ec&scoped=true&"
import script from "./GoalDialog.vue?vue&type=script&lang=js&"
export * from "./GoalDialog.vue?vue&type=script&lang=js&"
import style0 from "./GoalDialog.vue?vue&type=style&index=0&id=51bd53ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bd53ec",
  null
  
)

export default component.exports